/* Saber Legacy — lupa a pantalla completa para la galería de producto.
 *
 * Se abre tocando la foto grande o el botón de la esquina. Dentro:
 *   - un clic alterna entre ver la foto completa y verla a tamaño real
 *   - con el mouse se arrastra para recorrerla; en táctil se desliza y se
 *     pellizca, que el navegador ya lo hace solo dentro de un contenedor
 *     con overflow:auto
 *   - flechas del teclado o los botones laterales para pasar de foto
 *   - Esc, la X, o un clic en el fondo para cerrar
 *
 * Los videos no entran a la lupa: se ven en la galería con sus controles.
 *
 * La imagen se pide a 2400 px de ancho. Shopify no agranda: si el original
 * mide menos, sirve el original. Por eso el zoom luce distinto según el
 * sable — hay fotos de 4000 px y otras de 1024.
 */
(function () {
  'use strict';

  var gal = document.querySelector('.sl-gal');
  var caja = document.querySelector('[data-slz]');
  if (!gal || !caja) return;

  /* Se saca del árbol de la ficha para que ningún contenedor con transform
     o overflow le rompa el position:fixed. */
  document.body.appendChild(caja);

  var img = caja.querySelector('[data-slz-img]');
  var pista = caja.querySelector('[data-slz-hint]');
  var stage = caja.querySelector('[data-slz-stage]');
  if (!img || !stage) return;

  /* La lista sale de las MINIATURAS, no de cualquier cosa con data-slz-full:
     la imagen principal también lo lleva, y si se cuela se duplica la primera
     foto y todos los índices se corren. Si el producto trae un solo medio no
     hay miniaturas, y ahí sí se cae a la imagen principal. */
  var fotos = Array.prototype.filter.call(
    gal.querySelectorAll('.sl-gal__thumbs [data-slz-full]'),
    function (t) { return t.getAttribute('data-sl-mtype') !== 'video'; }
  );
  if (!fotos.length) {
    var sola = gal.querySelector('.sl-gal__main[data-slz-full]');
    if (sola) fotos = [sola];
  }
  if (!fotos.length) return;

  var i = 0;
  var movido = false;

  function pintar() {
    var t = fotos[i];
    img.src = t.getAttribute('data-slz-full');
    img.alt = t.getAttribute('data-slz-alt') || '';
    caja.classList.remove('slz--zoom');
    stage.scrollTop = 0;
    stage.scrollLeft = 0;
    if (pista) {
      pista.textContent = fotos.length > 1
        ? (i + 1) + ' de ' + fotos.length + '  ·  toca la imagen para acercar'
        : 'Toca la imagen para acercar';
    }
  }

  function indiceActual() {
    for (var k = 0; k < fotos.length; k++) {
      if (fotos[k].getAttribute('aria-current') === 'true') return k;
    }
    return 0;
  }

  function abrir(idx) {
    i = Math.max(0, Math.min(idx, fotos.length - 1));
    pintar();
    caja.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function cerrar() {
    caja.hidden = true;
    caja.classList.remove('slz--zoom');
    document.body.style.overflow = '';
  }

  function mover(d) {
    i = (i + d + fotos.length) % fotos.length;
    pintar();
  }

  function alternarZoom(ev) {
    if (caja.classList.contains('slz--zoom')) {
      caja.classList.remove('slz--zoom');
      stage.scrollTop = 0;
      stage.scrollLeft = 0;
      return;
    }

    /* Se mide ANTES de ampliar, con la foto todavía ajustada a la pantalla.
       Si se mide después, el rectángulo ya es el de la foto grande y la
       proporción sale mal: el clic termina cayendo en otro punto. */
    var r = img.getBoundingClientRect();
    var fx = ev && r.width ? (ev.clientX - r.left) / r.width : 0.5;
    var fy = ev && r.height ? (ev.clientY - r.top) / r.height : 0.5;
    fx = Math.min(1, Math.max(0, fx));
    fy = Math.min(1, Math.max(0, fy));

    caja.classList.add('slz--zoom');

    /* El destino se calcula con la resolución real de la foto y el tamaño de
       la ventana, no leyendo scrollWidth/scrollHeight. Esos dos dependen de
       que el navegador ya haya recalculado la maquetación tras el cambio de
       clase, y ahí la cuenta salía en cero. naturalWidth se conoce desde que
       la imagen carga, y en modo ampliado se muestra a tamaño real. */
    var objetivoX = fx * Math.max(0, img.naturalWidth - stage.clientWidth);
    var objetivoY = fy * Math.max(0, img.naturalHeight - stage.clientHeight);
    function colocar() {
      stage.scrollLeft = objetivoX;
      stage.scrollTop = objetivoY;
    }
    /* Dos intentos: el cuadro siguiente y un respiro después, por si el
       navegador reajusta el desplazamiento al cambiar el tamaño del contenido. */
    requestAnimationFrame(colocar);
    setTimeout(colocar, 60);
  }

  /* ---------- abrir ---------- */
  var principal = gal.querySelector('.sl-gal__main');
  if (principal) {
    principal.addEventListener('click', function () { abrir(indiceActual()); });
  }
  var lupa = gal.querySelector('[data-sl-zoom]');
  if (lupa) {
    lupa.addEventListener('click', function (e) {
      e.preventDefault();
      abrir(indiceActual());
    });
  }

  /* ---------- controles ---------- */
  var bx = caja.querySelector('[data-slz-close]');
  if (bx) bx.addEventListener('click', cerrar);

  var bp = caja.querySelector('[data-slz-prev]');
  if (bp) bp.addEventListener('click', function (e) { e.stopPropagation(); mover(-1); });

  var bn = caja.querySelector('[data-slz-next]');
  if (bn) bn.addEventListener('click', function (e) { e.stopPropagation(); mover(1); });

  img.addEventListener('click', function (e) {
    e.stopPropagation();
    if (movido) { movido = false; return; }
    alternarZoom(e);
  });

  /* clic en el fondo, fuera de la foto */
  stage.addEventListener('click', function (e) {
    if (e.target === stage) cerrar();
  });

  document.addEventListener('keydown', function (e) {
    if (caja.hidden) return;
    if (e.key === 'Escape') cerrar();
    else if (e.key === 'ArrowLeft') mover(-1);
    else if (e.key === 'ArrowRight') mover(1);
  });

  /* ---------- arrastrar para recorrer (mouse) ---------- */
  var arrastrando = false, x0 = 0, y0 = 0, sl0 = 0, st0 = 0;

  stage.addEventListener('pointerdown', function (e) {
    movido = false;
    if (!caja.classList.contains('slz--zoom')) return;
    if (e.pointerType === 'touch') return; /* el táctil ya se desplaza solo */
    arrastrando = true;
    caja.classList.add('slz--drag');
    x0 = e.clientX; y0 = e.clientY;
    sl0 = stage.scrollLeft; st0 = stage.scrollTop;
    try { stage.setPointerCapture(e.pointerId); } catch (err) {}
  });

  stage.addEventListener('pointermove', function (e) {
    if (!arrastrando) return;
    var dx = e.clientX - x0, dy = e.clientY - y0;
    if (Math.abs(dx) > 6 || Math.abs(dy) > 6) movido = true;
    stage.scrollLeft = sl0 - dx;
    stage.scrollTop = st0 - dy;
  });

  function soltar() {
    if (!arrastrando) return;
    arrastrando = false;
    caja.classList.remove('slz--drag');
  }
  stage.addEventListener('pointerup', soltar);
  stage.addEventListener('pointercancel', soltar);
})();
